import { ReactNode, useState } from "react";

import CustomerAttribute, {
  CustomerAttributeProps,
} from "~/components/common/CustomerAttribute";

type Props = CustomerAttributeProps & {
  renderEditForm: (onDone: () => void) => ReactNode;
  // when true, hide the edit affordance (no onEdit) so the value is read-only
  isReadOnly?: boolean;
};

// extends CustomerAttribute component to make it editable
// receives a renderEditForm function that returns a ReactNode
// the renderEditForm function receives a onDone function that should be called when the edit is done or cancelled
export function EditableCustomerAttribute({
  isCopyable,
  isReadOnly,
  renderEditForm,
  children,
  ...restProps
}: Props) {
  const [isEditing, setIsEditing] = useState(false);
  // never show the edit form while read-only, even if editing was in progress
  // when the field flipped to read-only
  const showEditForm = isEditing && !isReadOnly;
  return (
    <CustomerAttribute
      {...restProps}
      onEdit={
        isReadOnly ? undefined : () => setIsEditing((isEditing) => !isEditing)
      }
      // disable copying when editing since it overlaps with the form elements
      // and doesn't make sense to copy the value when editing
      isCopyable={showEditForm ? false : isCopyable}
    >
      {showEditForm ? renderEditForm(() => setIsEditing(false)) : children}
    </CustomerAttribute>
  );
}
